import { IApiResponse } from "../../../../@types/api-response.type"
import { ILanguagesDto } from "../../../../@types/curriculum.type"
import { Api } from "../../ApiConfig"
import { ApiException } from "../../ApiException"
import { getErrorMessage } from "../../../../utils/utils"

export const getAllLanguageReference = async () : Promise<ILanguagesDto[]> => {
  try {
      const { data } = await Api.get<IApiResponse<ILanguagesDto[]>>(`/api/Language/GetAllLanguage`)
      return data.result
  } catch (error) {
      throw new ApiException(getErrorMessage(error, 'Erro ao consultar idiomas'))
  }  
}
